import { DateField } from '@mi-front/ui';
import { CalendarMonth as CalendarIcon } from '@mui/icons-material';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';
import { useTimezone } from '@app/core/hooks/useTimezone';

export type Props = object;

export function SchedulesListMentionsIndexForm(p: Props) {
  const tz = useTimezone();
  const { $t } = useIntl();

  return (
    <div className={'row'}>
      <div className="col-md-3">
        <DateField
          label={$t({
            id: 'common.date',
            defaultMessage: 'Fecha',
          })}
          name="date"
          icon={<CalendarIcon />}
          max={moment(new Date()).tz(tz).format('YYYY-MM-DD')}
          isOutsideRange={(date) => moment(date) > moment()}
        />
      </div>
    </div>
  );
}
